export default class FontData {
  constructor(
    public family: string,
    public color: string,
  ) {
  }
}
